<script lang="ts">
const intro1 = `Witness the ascent of beauty and strategy in the "Rankings by ROMA". Here, digital charm powers the rise of the next Web3 queen, fueled by ROMA tokens.`
const intro2 = `Enter the arena of "Token Titans", where cryptocurrency meets pageantry. Explore the power players of crypto and see who claims the token throne.`
const intro3 = `Saluting the Patrons of Prestige, the driving force behind the throne. These top voters wield the power to uplift, crowning the champions with their generosity. `
</script>
<script setup lang="ts">
useHead({
  meta: [
    {
      name: 'description',
      content: 'Miss W - Redefine Influence',
    },
  ],
})



</script>

<template>
  <div w-full overflow-x-hidden>
    <MissWHeader
      cover="/images/image-167-missw.webp"
      title="MISS W"
      subtitle="REDEFINE INFLUENCE"
      intro="Be a Part of Korea’s Groundbreaking Web3.0 Event. Where Crypto meets Beauty, INFLUENCE is Born. Join the revolution. "
    />

    <div class="bg" lt-lg:mt-80px>
      <MissWCard
        cover="/images/contestants.webp"
        title="AMBASSADORS"
        subtitle="Elevate with Grace, <br>Reign with ROMA"
        :intro="intro1"
        cover-width="2660px"
        button="view contestants"
      />

      <MissWCard
        cover="/images/group-100000271621.webp"
        title="token tickets"
        subtitle="In Tokens We Trust, <br>In Beauty We Invest"
        :intro="intro2"
        button="get roma"
      />

      <MissWCard
        cover="/images/group-10000027171.webp"
        title="PATRONS"
        subtitle="Your Support, <br>Their Victory"
        :intro="intro3"
        button="vote now"
        url="https://missweb3.app"
      />

      <IntroductionSponsors class="lt-sm:mt--70px!" style="margin-top: -160px; background: transparent !important" />
    </div>
  </div>
</template>

<style scoped>
.bg {
  background: linear-gradient(
    180deg,
    #80000e 0%,
    #000 9.62%,
    #000 63.94%,
    #80000e 100%
  );
}
</style>
